import { render, staticRenderFns } from "./CrownIcon.vue?vue&type=template&id=639ce662&"
import script from "./CrownIcon.vue?vue&type=script&lang=js&"
export * from "./CrownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports